<template>
  <section class="w-full">
    <header class="bg-teal-800 text-teal-100 p-4 flex items-center space-x-4">
      <router-link :to="{ name: 'wizard' }">
        <h1 class="font-bold text-2xl">Heffron Wizards</h1>
      </router-link>
      <nav>
        <router-link :to="{ name: 'wizard-tbc' }">Transfer Balance Cap</router-link>
      </nav>
    </header>
    <router-view />
  </section>
</template>

<script>
export default {
  name: 'wizard-view',
};
</script>

<style>

</style>
